import { ChangeDetectionStrategy, Component } from '@angular/core';

import { IdentityFacade } from '@bp/admins-shared/domains/identity';

import { IntroFacade } from '../../../state';

@Component({
	selector: 'bp-create-account-page',
	templateUrl: './create-account-page.component.html',
	styleUrls: [ './create-account-page.component.scss' ],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreateAccountPageComponent {

	constructor(
		public introFacade: IntroFacade,
		public identityFacade: IdentityFacade,
	) { }

}
